import { useState, useEffect, useReducer, useRef } from "react";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { Popup } from "devextreme-react";

import * as ophActions from "../../actions/oph";
import ophReducer from "../../reducers/oph";
import * as dashboardActions from "../../actions/dashboard";
import smessReducer from "../../reducers/dashboard";
import moment, { duration } from "moment";
import NEXUS_CONST from "../../common/constants";
import AsyncCallHandler from "../../common/AsyncCallHandler";

import SmessCards from "./SmessCards";

const initialState = {
  shiftData: {
    shifts: [],
  },
};
const dashboardInitialState = { smessCards: null };

const SmessModal = (props) => {
  const [ShiftInfo, setShiftInfo] = useState([]);
  const [activeShiftNo, setActiveShiftNo] = useState();
  const [activeShiftInfo, setActiveShiftInfo] = useState({});

  const [modalVisible, setModalVisible] = useState(false);

  const isModalVisible = useRef(false);
  const isActiveShiftDataSaved = useRef(false);
  const lastActiveShift = useRef({});

  const [state, dispatch] = useReducer(ophReducer, initialState);
  const [dashboardState, dashboardDispatch] = useReducer(
    smessReducer,
    dashboardInitialState
  );

  const [ophDate, setOPHDate] = useState(
    props.siteDate ? props.siteDate : new Date()
  );

  const { tier } = useParams();

  const { tierInfo } = props;
  const { siteUID } = tierInfo;
  const trimmedSiteID = siteUID.split("_")[1];

  useEffect(() => {
    // ophActions.fetchShiftSchedule(dispatch, tier, siteUID);
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_DASHBOARD_DATA +
        siteUID +
        "&tierId=" +
        tier +
        "&userID=" +
        null +
        "&isStdDay=" +
        1 + // Need to remove this when removed from API E452130
        "&date=" +
        moment(ophDate).format("YYYY-MM-DD"),

      NEXUS_CONST.GET
    ).then((res) => {
      setShiftInfo(res.data.ophdata);
    });
  }, []);

  useEffect(() => {
    // Check Every 5 Seconds -> Shift is Active or not. based on that doing operation in popup
    const interval = setInterval(() => {
      if (!isEmpty(ShiftInfo)) {
        checkModalVisibility(ShiftInfo);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [ShiftInfo]);

  const getCurrentDayShiftData = (ShiftInfo) => {
    /* Returns Values after parsing the shift data, extracting required value for processing. */
    let shifts = ShiftInfo;
    const extractedShift = [];
    shifts.map((shift, i) => {
      const startTime = moment(shift.utcShiftStartTime);
      let endTime = moment(shift.utcShiftStartTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      let firstHrEndOn = moment(endTime, "YYYY-MM-DD HH:mm:ss").add(1, "hours");

      extractedShift.push({
        shiftNumber: i + 1,
        shiftStart: startTime,
        shiftEnd: endTime,
        shiftStartsAt: startTime.unix(),
        shiftEndsAt: firstHrEndOn.unix(),
      });
    });
    return extractedShift;
  };

  const getCurrentActiveShift = (currentDayShiftData) => {
    //Return Active Shift in Array of Object at the current time.
    let utcTime = moment().utc().format("YYYY-MM-DD HH:mm:ss");
    const currentTime = moment(utcTime, "YYYY-MM-DD HH:mm:ss").unix();
    return currentDayShiftData.filter((shift, ind) => {
      if (
        currentTime >= shift.shiftStartsAt &&
        currentTime <= shift.shiftEndsAt
      ) {
        return shift;
      }
    });
  };

  // Check popup visible conditions
  const checkModalVisibility = async (ShiftInfo) => {
    const activeShift = getCurrentActiveShift(
      getCurrentDayShiftData(ShiftInfo)
    );

    if (activeShift.length >= 1) {
      if (isModalVisible.current && !isActiveShiftDataSaved.current) {
        return;
      } else if (isActiveShiftDataSaved.current) {
        return;
      }

      lastActiveShift.current = activeShift?.[0];
      setActiveShiftInfo(() => activeShift?.[0]);
      setActiveShiftNo((prev) => activeShift?.[0]?.shiftNumber);

      const shiftCardData = await AsyncCallHandler(
        `SMESS/GetShiftwiseCardData?tierId=${tier}&shift=${activeShift?.[0]?.shiftNumber}`,
        NEXUS_CONST.GET
      );

      if (!shiftCardData.data.isSaved) {
        isModalVisible.current = true;
        setModalVisible(true);
      } else {
        isActiveShiftDataSaved.current = true;
      }
    } else {
      // Submit Default Data.

      isActiveShiftDataSaved.current = false;
      if (isModalVisible.current) {
        const shiftCards = await AsyncCallHandler(
          `SMESS/GetShiftwiseCardData?tierId=${tier}&shift=${lastActiveShift.current.shiftNumber}`,
          NEXUS_CONST.GET
        );

        const payload = [];
        shiftCards?.data?.cards?.map((d) => {
          payload.push({
            ...d,
            status: 2,
            reasonIDs: "0",
            tierID: tier,
            shiftID: lastActiveShift.current.shiftNumber,
          });
        });
        dashboardActions.saveSmessCards(
          dashboardDispatch,
          { smessCards: payload },
          {
            siteId: siteUID,
            tierId: tier,
            shiftNo: lastActiveShift.current.shiftNumber,
          }
        );
        isModalVisible.current = false;
        lastActiveShift.current = {};
        setModalVisible(false);
      }
    }
  };

  const renderTitle = () => {
    return (
      <h3 style={{ textAlign: "center", margin: "10px 0" }}>
        Shift {activeShiftNo} Tier 1: SMESS
      </h3>
    );
  };

  return (
    <Popup
      visible={modalVisible}
      hideOnOutsideClick={false}
      showTitle={true}
      titleRender={renderTitle}
      showCloseButton={false}
      dragEnabled={false}
      width={1020}
      height={500}
      onHiding={() => {
        (isModalVisible.current = false); setModalVisible(false);
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isModalVisible.current && (
          <SmessCards
            shiftInfo={state.shiftData}
            siteId={siteUID}
            tierId={tier}
            shiftNo={activeShiftNo}
            onClose={() => {
              (isModalVisible.current = false); setModalVisible(false);
            }}
            tierInfo={tierInfo}
          />
        )}
      </div>
    </Popup>
  );
};

export default SmessModal;
